import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";
import { BaseResponse } from "../_types";
import { QueryKeys } from "../queryKeys";

interface ISearchMobilEftPosRequest {
  taxNo: string;
}

type ISearchMobilEftPosResponse = BaseResponse<any>;

async function searchMobilEftPos(taxNo: string): Promise<ISearchMobilEftPosResponse> {
  try {
    const response = await axiosInstance.get("/Todeb/SearchMobileEftPos", {
      params: { taxNo }
    });
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any)?.error;
  }
}

export function useSearchMobilEftPos(taxNo?: string) {
  return useQuery<any | undefined, Error>(
    [QueryKeys.SearchMobilEftPos, taxNo],
    () => searchMobilEftPos(taxNo!),
    { enabled: !!taxNo }
  );
}
